import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SalePlatformIcon from './SalePlatformIcon';
import moment from 'moment';

const base = 'cooking-v2';

@inject('ProductionStore')
@observer
class OrderCategoryItems extends Component {
    state = {
        hours: '--',
        minutes: '--',
        seconds: '--',
        appearTimestamp: null,
        isNewOrder: false
    };

    componentDidMount = () => {
        this.setCountdown();
    };

    resetCountdown = () => {
        if (this.interval) clearInterval(this.interval);
        this.setState({
            hours: '--',
            minutes: '--',
            seconds: '--',
            delay: false,
        });
    };

    setCountdown = () => {
        this.interval = setInterval(this.countdown, 1000);
    };

    countdown = () => {
        const { item } = this.props;
        const isTakeAway = item.pick_up_type == "TAKE_AWAY" || item.order_mode == "PICK_UP";
        const isScheduledPickup = isTakeAway && item.customer_self_pickup_at_outlet && item.delivery_time;

        const currentTime = moment();
        let timerStartAt = item.order_date ? item.order_date : item.created_date;
        let duration = 0;

        if (item.pick_up_type == "DINE_IN") {
            timerStartAt = item.production_started_at ? item.production_started_at : item.order_date;
            duration = moment.duration(
                currentTime.diff(moment(timerStartAt ? timerStartAt : item.created_date, 'x'))
            ).asMilliseconds();
        } else if (isTakeAway && isScheduledPickup && !item.production_started_at) {
            // Align scheduled pickup timer with packing screen:
            // count down to pickup time, then count up after missed pickup time.
            const scheduledPickupTime = moment(item.delivery_time, 'x');
            duration = scheduledPickupTime.isAfter(currentTime)
                ? moment.duration(scheduledPickupTime.diff(currentTime)).asMilliseconds()
                : moment.duration(currentTime.diff(scheduledPickupTime)).asMilliseconds();
        } else if (isTakeAway) {
            timerStartAt = item.production_started_at ? item.production_started_at : item.order_date;
            duration = moment.duration(
                currentTime.diff(moment(timerStartAt ? timerStartAt : item.created_date, 'x'))
            ).asMilliseconds();
        } else {
            timerStartAt = item.production_started_at;
            duration = moment.duration(
                currentTime.diff(moment(timerStartAt, 'x'))
            ).asMilliseconds();
        }

        const hours = moment.utc(duration).format('H');
        let minutes = moment.utc(duration).format('m');
        if (hours > 0) {
            minutes = moment.utc(duration).format('mm');
        }
        const seconds = moment.utc(duration).format('ss');
        this.setState({ hours, minutes, seconds});
        if (this.state.appearTimestamp == null) {
            this.setState({ hours, minutes, seconds, isNewOrder: true, appearTimestamp: currentTime });
        }
    }

    render() {
        const {
            hours,
            minutes,
            seconds,
        } = this.state;
        const {item} = this.props;
        let isPriorityOrder = item.pick_up_type != null && 
            !item.platform.includes('GrabFood') &&
            !item.platform.includes('FoodPanda') &&
            !item.platform.includes('ShopeeFood');

        let valueMealItems = null;

        if (item.isMainItem) {
            valueMealItems = item.value_meal_items;
        }

        return(
            <div className={`${base}__items display--flex`} style={isPriorityOrder ? {backgroundColor: '#FFDE66'} : {backgroundColor: '#FFFCF0'}}>
                <div className='display--flex' style={{alignItems: 'center', flex: 1, minWidth: 0}}>
                    <SalePlatformIcon
                        key={item.order_number ? item.order_number : item.pick_up_number}
                        item={item}
                    />
                    <div style={{padding: '0px 7px'}}>
                        {item.sku.length > 17 ? 
                            item.sku.substring(0, 15) + '...' : 
                            item.sku}

                        {valueMealItems && valueMealItems.map((valueMealItem) => (
                            <div className={`${base}__value_meal_items`}>
                                {valueMealItem.sku.length > 17 ? 
                                    valueMealItem.sku.substring(0, 15) + '...' : 
                                    valueMealItem.sku}
                            </div>
                        ))}
                        {item.not_served_by_insta_service_component_map &&
                            Object.entries(item.not_served_by_insta_service_component_map).map(
                                ([component, quantity]) => (
                                    <div
                                        key={component}
                                        className='display--flex'
                                        style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: '2px' }}
                                    >
                                        <div className={`${base}__component_name`}>
                                            {quantity} x {component}
                                        </div>
                                        <div className={`${base}__cook_tag`}> COOK </div>
                                    </div>
                                )
                            )
                        }

                        {valueMealItems && valueMealItems.not_served_by_insta_service_component_map &&
                            Object.entries(valueMealItems.not_served_by_insta_service_component_map).map(
                                ([component, quantity]) => (
                                    <div
                                        key={component}
                                        className='display--flex'
                                        style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: '2px' }}
                                    >
                                        <div className={`${base}__component_name`}>
                                            {quantity} x {component}
                                        </div>
                                        <div className={`${base}__cook_tag`}> COOK </div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
                <div className={`${base}__timer`}>
                    {`${
                        parseInt(hours) > 0 ? `${hours}:` : ``
                    }${minutes}:${seconds}`}
                </div>
            </div>
        )
    }

}

export default OrderCategoryItems;
